var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[_c('v-list-item-content',[_vm._v("Is Prepaid?:")]),_c('v-list-item-content',{staticStyle:{"display":"inline-block"}},[(_vm.status)?_c('g-payment-status-chip',{attrs:{"text":_vm.prepaymentText(_vm.status),"color":"deep-purple darken-3"}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }